/* Combos Sirena — "Completa tu instalación" (v2: selector de opción/medida). Marca el carrito con _combo_sirena para medir ventas. */
(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return withDots;
      return withCommas;
    });
  }

  function init(root) {
    if (root.__smc) return;
    root.__smc = true;

    var format = root.getAttribute('data-smc-money');
    var totalEl = root.querySelector('[data-smc-total]');
    var button = root.querySelector('[data-smc-add]');
    var msg = root.querySelector('[data-smc-msg]');
    var mainBox = root.querySelector('[data-smc-main]');
    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-smc-variants]').textContent); } catch (e) {}

    var section = root.closest('[id^="shopify-section"]') || document;
    var form = section.querySelector('.product-block-list__item--info form[action*="/cart/add"]') ||
               section.querySelector('form[action*="/cart/add"]');

    function boxes() { return Array.prototype.slice.call(root.querySelectorAll('input[data-smc-variant]')); }
    function listo(box) { return box.checked && !box.disabled && box.getAttribute('data-smc-variant'); }
    function cantidad(box) {
      var input = box.closest('.smc__item').querySelector('[data-smc-qty]');
      var n = Math.min(999, Math.max(1, parseInt(input && input.value, 10) || 1));
      if (input && String(n) !== input.value) input.value = n;
      return n;
    }

    function refresh() {
      var total = 0, count = 0;
      boxes().forEach(function (box) {
        var item = box.closest('.smc__item');
        if (item) item.classList.toggle('is-off', !listo(box));
        if (listo(box)) { total += (parseInt(box.getAttribute('data-smc-price'), 10) || 0) * cantidad(box); count++; }
      });
      totalEl.textContent = money(total, format);
      button.disabled = count === 0;
      button.textContent = count <= 1 ? 'Agregar al carrito' : 'Agregar los ' + count + ' al carrito';
    }

    function show(text, isError) {
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
    }

    function syncMainVariant() {
      if (!form || !mainBox) return;
      var input = form.querySelector('[name="id"]');
      if (!input || !input.value || !variants[input.value]) return;
      var v = variants[input.value];
      mainBox.setAttribute('data-smc-variant', input.value);
      mainBox.setAttribute('data-smc-price', v.p);
      mainBox.disabled = !v.a;
      if (!v.a) mainBox.checked = false;
      var priceEl = root.querySelector('[data-smc-main-price]');
      var titleEl = root.querySelector('[data-smc-main-title]');
      if (priceEl) priceEl.textContent = money(v.p, format);
      if (titleEl && v.t !== 'Default Title') titleEl.textContent = v.t;
      refresh();
    }

    // Botones − / + de cantidad
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-smc-step]');
      if (!step) return;
      var input = step.parentNode.querySelector('[data-smc-qty]');
      input.value = Math.min(999, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-smc-step'), 10)));
      var box = step.closest('.smc__item').querySelector('input[data-smc-variant]');
      if (box && !box.checked && box.getAttribute('data-smc-variant')) box.checked = true;
      refresh();
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-smc-qty]') && e.target.value !== '') refresh();
    });

    // Selector de opción / medida de un recomendado
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-smc-qty]')) { refresh(); return; }
      var sel = e.target.closest('[data-smc-select]');
      if (sel) {
        var item = sel.closest('.smc__item');
        var box = item.querySelector('input[data-smc-variant]');
        var opt = sel.options[sel.selectedIndex];
        sel.classList.remove('is-required');
        if (opt && opt.value) {
          box.setAttribute('data-smc-variant', opt.value);
          box.setAttribute('data-smc-price', opt.getAttribute('data-price'));
          box.checked = true;
          var label = item.querySelector('[data-smc-price-label]');
          if (label) label.textContent = money(parseInt(opt.getAttribute('data-price'), 10) || 0, format);
        }
        refresh();
        return;
      }
      var chk = e.target.closest('input[data-smc-variant]');
      if (chk) {
        if (chk.checked && !chk.getAttribute('data-smc-variant')) {
          // pide medida: primero hay que elegirla
          chk.checked = false;
          var s = chk.closest('.smc__item').querySelector('[data-smc-select]');
          if (s) { s.classList.add('is-required'); s.focus(); }
          show('Elige la medida antes de agregarlo.', true);
        }
        refresh();
      }
    });
    // La cantidad del producto principal arranca igual a la que el cliente puso en la página
    function syncMainQty() {
      var formQty = form && form.querySelector('[name="quantity"]');
      var mainQty = root.querySelector('[data-smc-main-qty]');
      if (formQty && mainQty && parseInt(formQty.value, 10) > 0) mainQty.value = parseInt(formQty.value, 10);
      refresh();
    }
    if (form) {
      form.addEventListener('change', function () { setTimeout(function () { syncMainVariant(); syncMainQty(); }, 50); });
      document.addEventListener('variant:changed', function () { setTimeout(syncMainVariant, 50); });
    }

    button.addEventListener('click', function () {
      var items = boxes().filter(listo).map(function (b) {
        return { id: parseInt(b.getAttribute('data-smc-variant'), 10), quantity: cantidad(b) };
      });
      if (!items.length) return;

      button.disabled = true;
      msg.hidden = true;
      var extras = items.filter(function (it) { return String(it.id) !== mainBox.getAttribute('data-smc-variant'); })
                        .map(function (it) { return it.id; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'No se pudo agregar');
          // Marca del combo para medir ventas (atributo oculto en el checkout)
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var prev = (cart.attributes && cart.attributes._combo_sirena) || '';
              var entry = root.getAttribute('data-smc-product') + ':' + extras.join('+');
              var value = prev ? prev + ',' + entry : entry;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes: { _combo_sirena: value.slice(-250) } })
              });
            })
            .catch(function () {});
        })
        .then(function () {
          var qty = items.reduce(function (s, it) { return s + it.quantity; }, 0);
          if (window.theme && window.theme.cartType === 'page') {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            return;
          }
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true, detail: { variant: null, quantity: qty, button: button }
          }));
          show('¡Listo! Se agregaron ' + items.length + ' productos al carrito.');
          button.disabled = false;
        })
        .catch(function (err) {
          show(err.message || 'No se pudo agregar. Intenta de nuevo.', true);
          button.disabled = false;
        });
    });

    syncMainVariant();
    syncMainQty();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-smc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
